
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/plumbing/[query]",
      function () {
        return require("private-next-pages/services/plumbing/[query].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/plumbing/[query]"])
      });
    }
  